/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_My_GroupsInputs */

const en_nav_my_groups = /** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Groups`)
};

const id_nav_my_groups = /** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup Saya`)
};

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const es_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const fr_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const de_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const ja_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const zh_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const ar_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const it_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const ru_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const pt_nav_my_groups = en_nav_my_groups;

/** @type {(inputs: Nav_My_GroupsInputs) => LocalizedString} */
const ko_nav_my_groups = en_nav_my_groups;

/**
* | output |
* | --- |
* | "My Groups" |
*
* @param {Nav_My_GroupsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_my_groups = /** @type {((inputs?: Nav_My_GroupsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_My_GroupsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_my_groups(inputs)
	if (locale === "es") return es_nav_my_groups(inputs)
	if (locale === "fr") return fr_nav_my_groups(inputs)
	if (locale === "de") return de_nav_my_groups(inputs)
	if (locale === "ja") return ja_nav_my_groups(inputs)
	if (locale === "zh") return zh_nav_my_groups(inputs)
	if (locale === "ar") return ar_nav_my_groups(inputs)
	if (locale === "id") return id_nav_my_groups(inputs)
	if (locale === "it") return it_nav_my_groups(inputs)
	if (locale === "ru") return ru_nav_my_groups(inputs)
	if (locale === "pt") return pt_nav_my_groups(inputs)
	return ko_nav_my_groups(inputs)
});